import React, { useContext } from 'react';

import { useArgoContext } from '@amzn/awsscm-argo-core';
import Footer from '@amzn/awsscm-argo-core/argo/ui/footer';
import { AppLayout } from '@amzn/awsui-components-react-v3/polaris';

import { ApolloProvider } from '@apollo/client';

import getApolloClient from './gql';
import { RECEIVE_STORAGE } from './hooks/useLocalStorage';
import Pages from './pages';
import { Context, Provider } from './store';
import { AppContextProvider, AppType } from './store/appContext';
import { ServiceContextProvider } from './store/serviceContext';
import { ServiceType } from './store/types';

import './styles.scss';

export const AppFooter = () => {
  return (
    <div id="awsscm-footer">
      <Footer />
    </div>
  );
};

export const WithAppLayout = () => {
  return (
    <AppLayout
      content={<Pages />}
      navigation={null}
      breadcrumbs={null}
      footerSelector="#awsscm-footer"
      headerSelector="#awsscm-header"
      navigationHide
      toolsHide
    />
  );
};

export const WithArgo = () => {
  const context = useArgoContext();
  const initialState = useContext(Context);

  return (
    // Adding an Apollo provider high in the component tree makes it available for all children to access.
    // See https://www.apollographql.com/docs/react/get-started/ for more info.
    <AppContextProvider appType={AppType.ARGO} initialContext={context}>
      <ApolloProvider client={getApolloClient(context)}>
        <ServiceContextProvider serviceType={ServiceType.GRAPHQL}>
          <Provider initialState={{ ...initialState, hideLayout: false }} localStorageKey={RECEIVE_STORAGE}>
            <WithAppLayout />
            <AppFooter />
          </Provider>
        </ServiceContextProvider>
      </ApolloProvider>
    </AppContextProvider>
  );
};

export default function App() {
  // default ARGO App
  return <WithArgo />;
}
